import React from 'react';

import { ApiUserProfile } from '../../net/swagger';

// This data shape makes no sense
const guestUser: ApiUserProfile = {
	email: 'guest@haskoning.com',
	hasCreateProjectPrivilege: false,
	isGlobalAdmin: false,
	name: 'Guest',
	user: {
		email: 'guest@haskoning.com',
		globalAdmin: false,
		id: '0',
		name: 'Guest',
		haskoningUser: false,
	},
};

interface UserContextValue {
	signout(): void;
	user: ApiUserProfile;
}

const UserContext = React.createContext<UserContextValue>({ signout: () => null, user: guestUser });

export default UserContext;
